<template>
    <cell
        class="cursor-pointer"
        :background="'bg-gray-50 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-900'"
        @click.native="toggleCategoryOpen(category)"
    >
        <div class="w-full flex space-x-2 items-center">
            <icon
                :name="category.isOpen ? 'chevron-up' : 'chevron-down'"
                class="flex-shrink-0 h-full"
            />
            <span class="whitespace-nowrap font-bold">{{ category.name }}</span>
            <span
                v-if="category.primary_field"
                class="text-xxs text-gray-500 col-start-2 whitespace-nowrap font-bold"
            >
                    #{{ category.primary_field.number }}
                </span>
        </div>
    </cell>
</template>

<script>
import FieldCategory from '@/Models/FieldCategory';
import Cell from '@/Components/Storemanager/InitialColumn/Cell';

export default {
    components: {Cell},

    props: {
        category: FieldCategory,
    },

    methods: {
        toggleCategoryOpen(category) {
            this.$set(category, 'isOpen', !category.isOpen);
        },
    },
};
</script>
